<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w" v-if="current.nit">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span aria-expanded="false" class="nav-link active">
                <span class="tab-label">Saldo Pendiente:</span>
                <span class="tab-label badge text-danger">Q {{ current.saldo }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
              <h5 class="form-header" v-if="current.nit">Información de cliente &nbsp;&nbsp; <i class="fas fa-user-circle	fa-2x"></i></h5>
                <h5 class="form-header" v-if="current.nit == null">Nuevo Cliente</h5>
                <div class="form-desc" v-if="current.nit == null">
                  Adición de un Cliente para compra de productos o servicios
                </div>
                <div class="form-desc" v-if="current.nit != null">
                  Visualización de la información del cliente
                </div>
                <div class="row">
                  <div class="col-sm-3 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.nit,
                        }"
                        >NIT</label
                      >
                      <input
                        v-model="current.nit"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="NIT"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nit,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.nit"
                        class="form-text text-danger"
                        >{{ current.errors.nit[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-10">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors && current.errors.nombre,
                        }"
                        >Nombre</label
                      >
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nombre,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                        >{{ current.errors.nombre[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors && current.errors.direccion,
                        }"
                        >Dirección</label
                      >
                      <textarea
                        v-model="current.direccion"
                        class="form-control"
                        placeholder="Dirección"
                        autofocus="autofocus"
                        v-bind:class="{
                          'is-invalid':
                            current.errors && current.errors.direccion,
                        }"
                        type="text"
                      ></textarea>
                      <small
                        v-if="current.errors && current.errors.direccion"
                        class="form-text text-danger"
                        >{{ current.errors.direccion[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <ListasPrecioSelectComponent
                      titulo="Lista de Precio por Cliente"
                      :current="current"
                    />
                  </div>
                </div>

                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      class="nav-item nav-link active"
                      id="nav-home-tab"
                      data-toggle="tab"
                      href="#nav-home"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      >Información General</a
                    >
                    <a
                      class="nav-item nav-link"
                      id="direccion-tab"
                      data-toggle="tab"
                      href="#direccion"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="true"
                      >Dirección</a
                    >
                  </div>
                </nav>
                <div class="tab-content element-box" id="nav-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="row">
                      <div class="col-md-5">
                        <div class="form-group">
                          <label for>Teléfono 1</label>
                          <input
                            v-model="current.telefono"
                            class="form-control"
                            placeholder="Teléfono 1"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Teléfono 2</label>
                          <input
                            v-model="current.telefono2"
                            class="form-control"
                            placeholder="Teléfono 2"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Teléfono Móvil</label>
                          <input
                            v-model="current.telefono_movil"
                            class="form-control"
                            placeholder="Teléfono Móvil"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>FAX</label>
                          <input
                            v-model="current.fax"
                            class="form-control"
                            placeholder="FAX"
                            type="text"
                          />
                        </div>
                      </div>
                      <div class="col-md-5 offset-md-2">
                        <div class="form-group">
                          <label for>Persona Contacto</label>
                          <input
                            v-model="current.nombre_contacto"
                            class="form-control"
                            placeholder="Persona Contacto"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>DPI</label>
                          <input
                            v-model="current.dpi"
                            class="form-control"
                            placeholder="DPI"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Web Site</label>
                          <input
                            v-model="current.web_site"
                            class="form-control"
                            placeholder="Web Site"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.web_site"
                            class="form-text text-danger"
                            >{{ current.errors.web_site[0] }}</small
                          >
                        </div>
                        <div class="form-group">
                          <label for>Email</label>
                          <input
                            v-model="current.email"
                            class="form-control"
                            placeholder="Email"
                            type="text"
                          />
                          <small
                            v-if="current.errors && current.errors.email"
                            class="form-text text-danger"
                            >{{ current.errors.email[0] }}</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              name="optionsRadios"
                              v-model="current.activo"
                              type="radio"
                              value="true"
                            />Activo
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.activo"
                              name="optionsRadios"
                              type="radio"
                              value="false"
                            />Inactivo
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="direccion"
                    role="tabpanel"
                    aria-labelledby="direccion-tab"
                  >
                    <div class="row">
                      <div class="col-md-5">
                        <h6>Dirección Comercial</h6>
                        <br />
                        <div class="form-group">
                          <label>Dirección</label>
                          <textarea
                            v-model="current.fiscal_direccion"
                            class="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                        <div class="form-group">
                          <label for>Calle</label>
                          <input
                            v-model="current.fiscal_calle"
                            class="form-control"
                            placeholder="Calle"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Colonia</label>
                          <input
                            v-model="current.fiscal_colonia"
                            class="form-control"
                            placeholder="Colonia"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Ciudad</label>
                          <input
                            v-model="current.fiscal_ciudad"
                            class="form-control"
                            placeholder="Ciudad"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Pais</label>
                          <input
                            v-model="current.fiscal_pais"
                            class="form-control"
                            placeholder="Pais"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Estado</label>
                          <input
                            v-model="current.fiscal_estado"
                            class="form-control"
                            placeholder="Estado"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Codigo Postal</label>
                          <input
                            v-model="current.comercial_codigo_postal"
                            class="form-control"
                            placeholder="Codigo"
                            type="text"
                          />
                        </div>
                      </div>
                      <div class="col-md-5 offset-md-1">
                        <h6>Dirección Fiscal</h6>
                        <br />
                        <div class="form-group">
                          <label>Dirección</label>
                          <textarea
                            v-model="current.comercial_direccion"
                            class="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                        <div class="form-group">
                          <label for>Calle</label>
                          <input
                            v-model="current.comercial_calle"
                            class="form-control"
                            placeholder="Calle"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Colonia</label>
                          <input
                            v-model="current.comercial_colonia"
                            class="form-control"
                            placeholder="Colonia"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Ciudad</label>
                          <input
                            v-model="current.comercial_ciudad"
                            class="form-control"
                            placeholder="Ciudad"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Pais</label>
                          <input
                            v-model="current.comercial_pais"
                            class="form-control"
                            placeholder="Pais"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Estado</label>
                          <input
                            v-model="current.comercial_estado"
                            class="form-control"
                            placeholder="Estado"
                            type="text"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Codigo Postal</label>
                          <input
                            v-model="current.fiscal_codigo_postal"
                            class="form-control"
                            placeholder="Codigo"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-clientes', params: {} }"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ClienteService from "@/services/catalogos/ClienteService";
import Notifications from "@/notifications/notifications";
import ListasPrecioSelectComponent from "@/components/commons/ListasPrecioSelectComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
export default {
  components: {
    ListasPrecioSelectComponent,
  },
  data() {
    return {
      current: {
        nit: "",
        nombre: "",
        email: "",
        lista_precio: "",
        errors: {
          nombre: null,
        },
      },
    };
  },

  computed: {},
  mounted() {
    let self = this;
    self.refreshCurrent();
  },

  methods: {
    refreshCurrent() {
      let self = this;
      if (self.$route.params.nit) {
        ClienteService.getById(self.$route.params.nit).then((response) => {
          self.current = Object.assign(self.current, response.data);
          self.refreshListaPrecio();
        });
      }
    },
    refreshListaPrecio() {
      let self = this;
      if (self.current.lista_precio) {
        ListaPreciosService.getById(self.current.lista_precio).then(
          (response) => {
            self.current.lista_precio = response.data;
          }
        );
      }
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Cliente",
            "Se ha guardado la Información."
          );
          if (this.$route.params.nit) {
            self.refreshCurrent();
          }
          self.$router.push({
            name: "cat-clientes-editar",
            params: { nit: self.current.nit },
          });
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Ups :(", error.response.data.nit[0]);
          }
        });
    },
    howModal(e) {
      e.preventDefault();
    },
  },
};
</script>
